<template>
  <div class="flex flex-col items-center justify-center min-h-screen">
    <CustomContainer padding="p-8">
      <div class="flex flex-col items-center gap-4 text-center">
        <div v-if="loading" class="loading-container">
          <a-spin size="large" />
        </div>
        <template v-else>
          <div v-if="success" class="success-icon mb-4">
            <svg class="w-16 h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div v-else class="error-icon mb-4">
            <svg class="w-16 h-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
          <h1 class="text-2xl text_color font-semibold">{{ title }}</h1>
          <p class="text_color opacity-80">{{ message }}</p>
          <a-button class="primary_medium mt-4" @click="goToManageBilling">Return to Billing</a-button>
        </template>
      </div>
    </CustomContainer>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import CustomContainer from '@/components/custom/CustomContainer.vue';
import DashboardService from '@/services/DashboardService';
import { message } from 'ant-design-vue';

const router = useRouter();
const props = defineProps({
  sessionId: {
    type: String,
    required: true,
  },
});

const loading = ref(true);
const success = ref(false);
const title = ref('');
const messageRef = ref('');

const goToManageBilling = () => {
  router.push('/manage_billing');
};

const verifyCheckoutSession = async () => {
  try {
    const response = await DashboardService.verifyCheckoutSession(props.sessionId);
    if (response?.success) {
      success.value = true;
      title.value = 'Payment Successful!';
      messageRef.value = 'Your subscription has been updated successfully.';
    } else {
      success.value = false;
      title.value = 'Payment Verification Failed';
      messageRef.value = 'Unable to verify your payment. Please contact support if this issue persists.';
    }
  } catch (error) {
    console.error('Error verifying checkout session:', error);
    success.value = false;
    title.value = 'Payment Verification Failed';
    messageRef.value = 'An error occurred while verifying your payment. Please contact support.';
    message.error('Error verifying payment');
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  if (!props.sessionId) {
    success.value = false;
    title.value = 'Invalid Session';
    messageRef.value = 'No session ID provided.';
    loading.value = false;
    return;
  }
  await verifyCheckoutSession();
});
</script>

<style scoped>
.loading-container :deep(.ant-spin-dot-item) {
  background-color: white !important;
}

.loading-container :deep(.ant-spin) {
  color: white !important;
}
</style>
